<template>
  <nav class="navbar" :class="{ 'scrolled': isScrolled }">
    <div class="nav-container">
      <!-- Logo -->
      <router-link to="/" class="nav-logo">
        <div class="logo-icon">
          <img src="/icon.png" alt="Mio" />
        </div>
        <div class="logo-details">
          <span class="logo-name">Mio University</span>
          <span class="logo-subtitle">弥央大学</span>
        </div>
      </router-link>

      <!-- Desktop Menu -->
      <div class="nav-right">
        <ul class="nav-menu desktop-menu" :class="{ 'active': isMobileMenuOpen }">
          <li class="nav-item">
            <router-link to="/" class="nav-link">
              <i class="fas fa-home"></i>
              <span>首页</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/about" class="nav-link">
              <i class="fas fa-info-circle"></i>
              <span>关于</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/apply" class="nav-link">
              <i class="fas fa-graduation-cap"></i>
              <span>申请入学</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/links" class="nav-link">
              <i class="fas fa-link"></i>
              <span>友情链接</span>
            </router-link>
          </li>
        </ul>
        
        <!-- Search Box -->
        <div class="nav-search">
          <SearchBox />
        </div>
      </div>

      <!-- Mobile Menu Toggle -->
      <div class="mobile-menu-toggle" @click="toggleMobileMenu" :class="{ 'active': isMobileMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <!-- Mobile Menu Overlay -->
    <div class="mobile-menu-overlay" :class="{ 'active': isMobileMenuOpen }" @click="closeMobileMenu">
      <div class="mobile-menu">
        <div class="mobile-menu-header">
          <div class="mobile-logo">
            <span class="logo-text">弥央</span>
          </div>
          <button class="close-btn" @click="closeMobileMenu">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <ul class="mobile-nav-menu">
          <li class="mobile-search-item">
            <SearchBox @articleSelected="closeMobileMenu" />
          </li>
          <li><router-link to="/" @click="closeMobileMenu">首页</router-link></li>
          <li><router-link to="/about" @click="closeMobileMenu">关于</router-link></li>
          <li><router-link to="/apply" @click="closeMobileMenu">申请入学</router-link></li>
          <li><router-link to="/links" @click="closeMobileMenu">友情链接</router-link></li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import SearchBox from './SearchBox.vue'

export default {
  name: 'Navbar',
  components: {
    SearchBox
  },
  setup() {
    const isScrolled = ref(false)
    const isMobileMenuOpen = ref(false)

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 50
    }

    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value
      document.body.style.overflow = isMobileMenuOpen.value ? 'hidden' : 'auto'
    }

    const closeMobileMenu = () => {
      isMobileMenuOpen.value = false
      document.body.style.overflow = 'auto'
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
      document.body.style.overflow = 'auto'
    })

    return {
      isScrolled,
      isMobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid #eaeaea;
  z-index: 1000;
  transition: all 0.3s ease;

  &.scrolled {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  }
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
}

.nav-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  
  .logo-icon {
    width: 40px;
    height: 40px;
    margin-right: 0.75rem;
    border-radius: 8px;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  
  .logo-details {
    display: flex;
    flex-direction: column;
    
    .logo-name {
      font-weight: 700;
      font-size: 1.1rem;
      color: #111;
      line-height: 1;
    }
    
    .logo-subtitle {
      font-size: 0.7rem;
  color: #666;
      letter-spacing: 1px;
      font-weight: 500;
    }
  }
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-search {
  @media (max-width: 768px) {
    display: none;
  }
}

.desktop-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2rem;

  .nav-item {
    .nav-link {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      text-decoration: none;
      color: #333;
      font-weight: 500;
      padding: 0.5rem 1rem;
      border-radius: 4px;
      transition: all 0.3s ease;

      i {
        font-size: 0.9rem;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }

      &.router-link-active {
        background: rgba(0, 0, 0, 0.08);
      }
    }
  }
}

.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  cursor: pointer;
  padding: 0.5rem;
  
  span {
    width: 25px;
    height: 3px;
    background: #4a5568;
    margin: 3px 0;
    transition: 0.3s;
    border-radius: 2px;
  }
  
  &.active {
    span:nth-child(1) {
      transform: rotate(-45deg) translate(-5px, 6px);
    }
    span:nth-child(2) {
      opacity: 0;
    }
    span:nth-child(3) {
      transform: rotate(45deg) translate(-5px, -6px);
    }
  }
}

.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  pointer-events: none; // 未激活时不响应点击
  transition: all 0.3s ease;
  
  &.active {
    opacity: 1;
    visibility: visible;
    pointer-events: auto; // 激活时才可点击
  }
}

.mobile-menu {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background: white;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  
  .mobile-menu-overlay.active & {
    transform: translateX(0);
  }
}

.mobile-menu-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  .mobile-logo {
    .logo-text {
      font-family: 'Orbitron', sans-serif;
      font-weight: 900;
      font-size: 1.5rem;
      background: linear-gradient(135deg, #ff69b4 0%, #da70d6 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  
  .close-btn {
    background: none;
    border: none;
    font-size: 1.2rem;
    color: #4a5568;
    cursor: pointer;
    padding: 0.5rem;
  }
}

.mobile-nav-menu {
  list-style: none;
  padding: 1rem 0;
  margin: 0;
  
  li {
    &.mobile-search-item {
      padding: 1rem 1.5rem;
      border-bottom: 1px solid rgba(255, 105, 180, 0.1);
      
      ::v-deep(.search-box) {
        max-width: none;
        
        .search-input {
          width: 100%;
          border: 2px solid rgba(255, 105, 180, 0.2);
          
          &:focus {
            border-color: #ff69b4;
            box-shadow: 0 0 0 3px rgba(255, 105, 180, 0.1);
          }
        }
        
        .search-results {
          position: static;
          box-shadow: none;
          border: 1px solid rgba(255, 105, 180, 0.2);
          margin-top: 0.5rem;
          max-height: 300px;
        }
      }
    }
    
    a {
      display: block;
      padding: 1rem 1.5rem;
      text-decoration: none;
      color: #4a5568;
      font-weight: 500;
      border-bottom: 1px solid rgba(255, 105, 180, 0.1);
      transition: all 0.3s ease;
      
      &:hover, &.router-link-active {
        color: #ff69b4;
        background: linear-gradient(135deg, rgba(255, 105, 180, 0.1), rgba(218, 112, 214, 0.1));
        border-left: 4px solid #ff69b4;
        box-shadow: 0 2px 10px rgba(255, 105, 180, 0.2);
      }
    }
  }
}

@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }
  
  .mobile-menu-toggle {
    display: flex;
  }
  
  .nav-container {
    padding: 0 1rem;
  }
}
</style>
